import {
  ActionButton,
  ActionsGroup,
  Col,
  Entidade,
  InputInteger,
  PagedResponse,
  Row,
  Table
} from '@elotech/components';
import { AxiosPromise } from 'axios';
import { useState } from 'react';

import { useLoading } from '../../../../hooks';
import { ProtocoloService } from '../../../../service';
import { ProtocoloDTO } from '../../../../type';
import { InlineButton } from '../../../inline-button';
import { EntidadeSearch } from '../../../search';
import { TableContainer } from '../../../table';

const entidadeDefault = {
  id: '',
  brasao: '',
  cnpj: '',
  nome: '',
  principal: false
};

type Props = {
  onAddProtocolo: (protocolo: ProtocoloDTO) => void;
  onEntidadeSearch?: (
    search: string,
    pagination?: any,
    sort?: any
  ) => AxiosPromise<PagedResponse<Entidade>>;
  addedIds?: string[];
};

export const ProtocoloSelect = ({
  onEntidadeSearch,
  addedIds,
  onAddProtocolo
}: Props) => {
  const [protocolos, setProtocolos] = useState<ProtocoloDTO[]>();
  const [entidade, setEntidade] = useState<Entidade>(entidadeDefault);

  const [numero, setNumero] = useState('');
  const [ano, setAno] = useState('');

  const [loading, setLoading] = useLoading();

  const onSearchProtocolo = () => {
    setLoading(
      ProtocoloService.findAllProcesso(numero, ano, entidade?.id).then(
        ({ data }) => {
          setProtocolos?.(
            data.content.filter(filter => !addedIds?.includes(filter.uuid!))
          );
        }
      )
    );
  };

  const onLimparFiltros = () => {
    setProtocolos(undefined);
    setEntidade(entidadeDefault);
    setNumero('');
    setAno('');
  };

  const showEntidadeColumn = () => {
    return onEntidadeSearch ? (
      <Table.Column
        name="entidade"
        header="Entidade"
        value={(protocolo: ProtocoloDTO) => {
          return `${protocolo.entidade?.id} - ${protocolo.entidade?.nome}`;
        }}
      />
    ) : undefined;
  };

  return (
    <>
      <Row>
        {onEntidadeSearch ? (
          <>
            <EntidadeSearch
              size={4}
              name="entidade"
              value={entidade && entidade.id ? entidade : undefined}
              onSearch={onEntidadeSearch}
              onSelect={(_: string, value: Entidade): void => {
                setEntidade(value);
              }}
              disableFormGroup={true}
            />
          </>
        ) : (
          <></>
        )}
        <Col md={2}>
          <label className="label">Número</label>
          <InputInteger
            value={numero}
            name="numero"
            type="text"
            size={2}
            onChange={event => setNumero(event.target!.value)}
          />
        </Col>
        <Col md={2}>
          <label className="label">Ano</label>
          <InputInteger
            value={ano}
            name="ano"
            type="text"
            size={2}
            onChange={event => setAno(event.target!.value)}
          />
        </Col>
        <Col sm={4}>
          <InlineButton
            label={'Pesquisar'}
            className="mt-xs"
            icon="fa fa-search"
            onClick={onSearchProtocolo}
          />
          <InlineButton
            label={'Limpar'}
            className="mt-xs"
            data-testid="addButton"
            icon="fa fa-trash"
            onClick={onLimparFiltros}
          />
        </Col>
      </Row>

      <TableContainer>
        <Table values={protocolos || []} loading={loading}>
          {showEntidadeColumn()}
          <Table.Column
            name="numero"
            header="Número"
            value={(protocolo: ProtocoloDTO) => protocolo.numero}
          />
          <Table.Column
            name="ano"
            header="Ano"
            value={(protocolo: ProtocoloDTO) => protocolo.ano}
          />
          <Table.Column
            name="situacao"
            header="Situação"
            value={(protocolo: ProtocoloDTO) => protocolo.situacao.descricao}
          />
          <Table.Column
            name="requerente"
            header="Requerente"
            value={(protocolo: ProtocoloDTO) => protocolo.pessoa?.nome}
          />
          <Table.Column
            name="assunto"
            header="Assunto"
            value={(protocolo: ProtocoloDTO) =>
              `${protocolo.assunto?.id} - ${protocolo.assunto?.descricao}`
            }
          />
          <Table.Column
            name="tipo"
            header="Tipo"
            value={(protocolo: ProtocoloDTO) =>
              `${protocolo.tipo?.id} - ${protocolo.tipo?.descricao}`
            }
          />
          <Table.Column
            name="observacao"
            header="Observação"
            value={(protocolo: ProtocoloDTO) => protocolo.observacao}
          />

          <Table.Column
            header=""
            value={(protocolo: ProtocoloDTO) => {
              return (
                <ActionsGroup>
                  <ActionButton
                    key="add-button"
                    label="Vincular Protocolo"
                    icon="plus"
                    onClick={() => onAddProtocolo(protocolo)}
                  />
                </ActionsGroup>
              );
            }}
          />
        </Table>
      </TableContainer>
    </>
  );
};
